(function () {
  var root = document.querySelector('[data-lpb-gamification]');
  if (!root) return;

  var trigger = root.querySelector('[data-lpb-celebrate]');
  var layer = root.querySelector('[data-lpb-celebration]');
  if (!trigger || !layer) return;

  var flakeImages = [
    'https://cdn.shopify.com/s/files/1/0864/2071/7909/files/logo_green.svg?v=1749736087',
    'https://cdn.shopify.com/s/files/1/0864/2071/7909/files/logo_pink.svg?v=1749736088',
    'https://cdn.shopify.com/s/files/1/0864/2071/7909/files/logo_blue.svg?v=1749736087',
    'https://cdn.shopify.com/s/files/1/0864/2071/7909/files/logo_purple.svg?v=1749736087',
    'https://cdn.shopify.com/s/files/1/0864/2071/7909/files/logo_yellow.svg?v=1749736087'
  ];

  function celebrate() {
    layer.innerHTML = '';

    var count = window.innerWidth <= 749 ? 90 : 170;

    for (var i = 0; i < count; i += 1) {
      var flake = document.createElement('img');
      var size = Math.floor(Math.random() * 12) + 34;
      var startX = Math.floor(Math.random() * (window.innerWidth + 240)) - 120;
      var drift = Math.floor(Math.random() * 220) - 110;
      var rotate = Math.floor(Math.random() * 2400);
      var delay = Math.random() * 1.8;
      var duration = 2.6 + Math.random() * 1.4;

      flake.className = 'lpb-gamification__flake';
      flake.src = flakeImages[Math.floor(Math.random() * flakeImages.length)];
      flake.alt = '';
      flake.style.width = size + 'px';
      flake.style.height = size + 'px';
      flake.style.left = startX + 'px';
      flake.style.opacity = (0.45 + Math.random() * 0.55).toFixed(2);
      flake.style.setProperty('--flake-x', drift + 'px');
      flake.style.setProperty('--flake-rotate', rotate + 'deg');
      flake.style.animationDelay = delay + 's';
      flake.style.animationDuration = duration + 's';
      layer.appendChild(flake);

      flake.addEventListener('animationend', function (event) {
        event.currentTarget.remove();
      });
    }

    window.setTimeout(function () {
      layer.innerHTML = '';
    }, 4600);
  }

  trigger.addEventListener('click', celebrate);
})();
